/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class DeleteRunningJobsMutation extends Relay.Mutation {
    static propTypes = {
        beforeDate: PropTypes.string,
        organisation: PropTypes.object,
    };

    getMutation() {
        return Relay.QL`mutation {deleteRunningJobs}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on DeleteRunningJobsPayload {
                runningJobs
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            beforeDate: this.props.beforeDate,
            organisation_id: this.props.organisation ? this.props.organisation.realId : undefined,
        };
    }
}
